<template>
  <div class="query-detail">
    <!-- 保险信息 -->
    <div class="description">
      <div class="qd-header">
        <span>保险信息</span>
        <div class="divider"></div>
      </div>
      <div class="qd-title" style="color:#fe7b28">
        商品名称：{{ orderInfo.goodsName }}
      </div>
      <div class="divider" style="margin-left: 85px"></div>
      <div class="content">
        <div class="desc-item">
          <span class="label">订单号：</span>
          <span class="text">{{ orderInfo.orderCode }}</span>
        </div>
        <div class="desc-item">
          <span class="label">原保费：</span>
          <span class="text">{{ orderInfo.firstYearPremium }}</span>
        </div>
        <div class="desc-item">
          <span class="label">保费金额：</span>
          <span class="text">{{ orderInfo.enquiryPremium }}</span>
        </div>
        <div class="desc-item">
          <span class="label">保额：</span>
          <span class="text">{{ orderInfo.amountDesc }}</span>
        </div>
        <div class="desc-item">
          <span class="label">订单状态：</span>
          <span class="text">{{ orderInfo.orderStatusDesc }}</span>
        </div>
        <div v-if="orderInfo.payInfo && orderInfo.payInfo.payChannel == 'agency'" class="desc-item">
          <span class="label">是否退款：</span>
          <span class="text">
            {{
              orderInfo.payInfo && orderInfo.payInfo.refundStatus == 1
                ? "是"
                : "否"
            }}</span>
        </div>
      </div>
    </div>
    <!-- 保单详情 -->
    <div class="description">
      <div class="qd-header">
        <span>保单详情</span>
        <div class="divider"></div>
      </div>
      <div class="content">
        <div class="desc-item">
          <span class="label">保险公司：</span>
          <span class="text"> {{ orderInfo.companyName }}</span>
        </div>
        <div class="desc-item">
          <span class="label">保单号：</span>
          <span class="text">{{ orderInfo.policyCode || "---" }}</span>
        </div>
        <div class="desc-item"></div>
        <!-- 直投 -->
        <template v-if="orderInfo && orderInfo.orderDetail && productInfos.length">
          <template v-for="item in productInfos">
            <div v-for="(el, i) in item.fields" :key="i" class="desc-item">
              <span class="label">{{ el.name }}：</span>
              <span class="text">{{ el.value }}</span>
            </div>
          </template>
        </template>
        <!-- 普通 -->
        <template v-if="
            orderInfo &&
              orderInfo.orderDetail == null &&
              orderInfo.productInfos &&
              orderInfo.productInfos.length
          ">
          <template v-for="(item, i) in orderInfo.productInfo">
            <div :key="i * 1.1" class="desc-item">
              <span class="label">保障期限：</span>
              <span class="text">
                {{ item.coverageType == 1 ? `保${item.coveragePeriod}年` : "" }}
                {{
                  item.coverageType == 2 && item.coveragePeriod != 105
                    ? `保至${item.coveragePeriod}岁`
                    : ""
                }}
                {{ item.coverageType == 3 ? `保${item.coveragePeriod}月` : "" }}
                {{ item.coverageType == 4 ? `保${item.coveragePeriod}天` : "" }}
                {{
                  item.coverageType == 2 && item.coveragePeriod == 105
                    ? "保终身"
                    : ""
                }}</span>
            </div>
            <div :key="i * 1.3" class="desc-item">
              <span class="label">险种类别：</span>
              <span class="text">{{
                item.mainAttachmentType == "1" ? "主险" : "附加险"
              }}</span>
            </div>
            <div :key="i * 1.4" class="desc-item">
              <span class="label">交费年期：</span>
              <span class="text">
                {{
                  item.payPeriodType == 1 &&
                  item.chargeYear != 1 &&
                  item.chargeYear != 0
                    ? `交${item.chargeYear}年`
                    : ""
                }}
                {{
                  item.payPeriodType == 2 && item.chargeYear != 0
                    ? `交至${item.chargeYear}岁`
                    : ""
                }}
                {{
                  (item.payPeriodType == 1 && item.chargeYear == 1) ||
                  item.chargeYear == 0
                    ? "趸交"
                    : ""
                }}</span>
            </div>
            <div :key="i * 1.5" class="desc-item">
              <span class="label">交费频率：</span>
              <span class="text">
                {{ item.payFrequencyType == 1 ? "趸交" : "" }}
                {{ item.payFrequencyType == 2 ? "年交" : "" }}
                {{ item.payFrequencyType == 3 ? "月交" : "" }}
                {{ item.payFrequencyType == 4 ? "季交" : "" }}
                {{ item.payFrequencyType == 5 ? "半年交" : "" }}
              </span>
            </div>
          </template>
        </template>
      </div>
    </div>
    <!-- 投保人信息 -->

    <div class="description">
      <div class="qd-header">
        <span>投保人信息</span>
        <div class="divider"></div>
      </div>
      <!-- 直投 -->
      <div v-if="
          orderInfo &&
            orderInfo.orderDetail &&
            orderInfo.orderDetail.proposer.length
        " class="content">
        <template v-for="(item, index) in orderInfo.orderDetail.proposer">
          <div :key="index" class="desc-item">
            <span class="label">{{ item.name }}：</span>
            <span class="text">{{ item.value }}</span>
          </div>
        </template>
      </div>
      <!-- 普通 -->
      <div v-if="orderInfo && orderInfo.orderDetail == null && orderInfo.proposer" class="content">
        <div class="desc-item">
          <span class="label">姓名：</span>
          <span class="text">{{ orderInfo.proposer.name }}</span>
        </div>
        <div class="desc-item">
          <span class="label">性别：</span>
          <span class="text"> {{ gender(orderInfo.proposer.gender) }}</span>
        </div>
        <div class="desc-item">
          <span class="label">证件类型：</span>
          <span class="text">
            {{ identityType(orderInfo.proposer.identityType) }}</span>
        </div>
        <div class="desc-item">
          <span class="label">证件号码：</span>
          <span class="text">
            {{ identityType(orderInfo.proposer.identityType) }}</span>
        </div>
        <div class="desc-item">
          <span class="label">联系电话：</span>
          <span class="text"> {{ orderInfo.proposer.mobile }}</span>
        </div>
        <div class="desc-item">
          <span class="label">邮箱：</span>
          <span class="text"> {{ orderInfo.proposer.email }}</span>
        </div>
        <div class="desc-item">
          <span class="label">出生日期：</span>
          <span class="text"> {{ orderInfo.proposer.birthday }}</span>
        </div>
        <div class="desc-item">
          <span class="label">年龄：</span>
          <span class="text"> {{ orderInfo.proposer.age }}</span>
        </div>
      </div>
    </div>
    <!-- 被保人信息 -->
    <div class="description">
      <div class="qd-header">
        <span>被保人信息</span>
        <div class="divider"></div>
      </div>
      <!-- 直投 -->

      <div v-if="
          orderInfo &&
            orderInfo.orderDetail &&
            orderInfo.insureds &&
            orderInfo.insureds.length
        " class="content">
        <template v-for="(val, index) in orderInfo.insureds">
          <p style="grid-column: 1/4" :key="index" v-if="orderInfo.insureds.length > 1">
            <el-divider content-position="left">
              被保人{{ index + 1 }}{{ index == 0 ? "（主被保人）" : "" }}
            </el-divider>
          </p>
          <div v-for="(item, idx) in val.userList" :key="idx" class="desc-item">
            <span class="label">{{ item.name }}：</span>
            <span class="text">{{ item.value }}</span>
          </div>
        </template>
      </div>
      <!-- 普通 -->
      <div v-if="
          orderInfo &&
            orderInfo.orderDetail == null &&
            orderInfo.insureds &&
            orderInfo.insureds.length
        " class="content">
        <template v-for="(obj, index) in orderInfo.insureds">
          <div :key="index" class="desc-item">
            <span class="label">与投保人关系：</span>
            <span class="text"> {{ relation(obj.relationWithProposer) }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">姓名：</span>
            <span class="text"> {{ obj.name }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">证件类型：</span>
            <span class="text"> {{ identityType(obj.identityType) }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">证件号码：</span>
            <span class="text"> {{ obj.identityCode }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">性别：</span>
            <span class="text"> {{ gender(obj.gender) }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">出生日期：</span>
            <span class="text"> {{ obj.birthday }}</span>
          </div>
        </template>
      </div>
    </div>
    <!-- 受益人信息 -->
    <div class="description">
      <div class="qd-header">
        <span>受益人信息</span>
        <div class="divider"></div>
      </div>
      <div v-if="
          orderInfo &&
            orderInfo.orderDetail &&
            orderInfo.benefit &&
            orderInfo.benefit.length
        " class="content">
        <template v-for="(item, index) in orderInfo.benefit">
          <p style="grid-column: 1/4" :key="index" v-if="orderInfo.benefit.length > 1">
            <el-divider content-position="left">被保人{{ index + 1
              }}{{ index == 0 ? "（主被保人）" : "" }}</el-divider>
          </p>
          <div :key="index" class="desc-item">
            <span class="label">受益人类型：</span>
            <span class="text">
              {{ item.legalBeneficiary == 1 ? "法定受益人" : "" }}
              {{ item.legalBeneficiary == 0 ? "指定受益人" : "" }}</span>
          </div>
          <template v-if="item.legalBeneficiary == 0">
            <template v-for="(elem, idx) in item.legalBeneficiary == 0 && item.userList">
              <div :key="idx" style="grid-column: 1/4">
                <el-divider content-position="left">
                  <div class="desc-item">
                    <span class="label">{{ "受益人" + "(" + item.userList.length + ")" }}：</span>
                    <span class="text">{{ idx + 1 }}</span>
                  </div>
                </el-divider>
              </div>
              <div :key="i" v-for="(el, i) in elem" class="desc-item">
                <span class="label">{{ el.name }}：</span>
                <span class="text">{{ el.value }}</span>
              </div>
            </template>
          </template>
        </template>
      </div>
      <div v-if="
          orderInfo &&
            orderInfo.orderDetail == null &&
            orderInfo.benefit &&
            orderInfo.benefit.length
        " class="content">
        <div :key="index" class="desc-item">
          <span class="label">受益人类型：</span>
          <span class="text">
            {{ orderInfo.benefit[0].legalBeneficiary == 1 ? "法定受益人" : "" }}
            {{ orderInfo.benefit[0].legalBeneficiary == 0 ? "指定受益人" : "" }}
          </span>
        </div>
        <template v-for="(obj, index) in orderInfo.benefit[0].beneficiaries">
          <div :key="index" class="desc-item">
            <span class="label">与被保人关系：</span>
            <span class="text"> {{ relation(obj.relationWithInsured) }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">姓名</span>
            <span class="text"> {{ obj.name }}</span>
          </div>
          <div :key="index" class="desc-item">
            <span class="label">受益比例</span>
            <span class="text"> {{ obj.benefitRatio }}%</span>
          </div>
        </template>
      </div>
    </div>
    <!-- 影像文件信息 -->
    <div v-if="orderInfo && orderInfo.orderDetail && imagesFiles.length" class="description">
      <div class="qd-header">
        <span style="width: 100px">影像文件信息</span>
        <div class="divider"></div>
      </div>
      <!-- 直投 -->
      <el-form v-if="orderInfo && orderInfo.orderDetail && imagesFiles.length" ref="orderInfo" :model="orderInfo"
        label-width="200px" style="margin-top:30px" size="medium" label-suffix="：">
        <el-row :gutter="10">
          <el-col v-for="(item, index) in imagesFiles" :key="index" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="item.name" prop="role_name">
              <el-image style="width: 120px; height: 60px" :src="item.value" :preview-src-list="[item.value]" />
              <!-- <img :src="item.value" class="img-detail-message-card" /> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 银行卡信息 -->
    <div class="description">
      <div class="qd-header">
        <span>投保人信息</span>
        <div class="divider"></div>
      </div>
      <!-- 直投 -->
      <template v-if="orderInfo && orderInfo.orderDetail && orderInfo.orderDetail.bank">
        <div class="content">
          <div :key="index" v-for="(item, index) in orderInfo.orderDetail.bank" class="desc-item">
            <span class="label">{{ item.name }}：</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </template>

      <!-- 普通 -->
      <div v-if="
          orderInfo && orderInfo.orderDetail == null && orderInfo.bankAccount
        " class="content">
        <div class="desc-item">
          <span class="label">姓名：</span>
          <span class="text"> {{ orderInfo.bankAccount.accountName }}</span>
        </div>
        <div class="desc-item">
          <span class="label">银行名称：</span>
          <span class="text"> {{ orderInfo.bankAccount.bankName }}</span>
        </div>
        <div class="desc-item">
          <span class="label">卡号：</span>
          <span class="text"> {{ orderInfo.bankAccount.bankAccountNo }}</span>
        </div>
      </div>
    </div>
    <div class="footer-area">
      <div @click="goBack" class="bottom-btn">返回》</div>
    </div>
  </div>
</template>

<script>
  // insureOrderRefund
  import {
    queryChaosOrderDetail
  } from "@/api/insideJobManage";
  import {
    payTypeList,
    beneTypeList,
    gradeTypeList,
    certiTypeList,
    sexTypeList,
    relationWithInsurantTypeList,
    policyStatusTypeList,
    goodsTypeList,
  } from "@/libs/dictList";
  import {
    relation,
    gender,
    identityType
  } from "@/utils/validate";
  import {
    flatten
  } from "@/utils/index";

  export default {
    name: "queryDetail",
    components: {},
    filters: {},
    props: {
      code: {
        type: [Number, String],
        default: "",
      },
    },
    data() {
      return {
        orderCode: this.$route.query.orderCode,
        payTypeList,
        beneTypeList,
        gradeTypeList,
        certiTypeList,
        sexTypeList,
        relationWithInsurantTypeList,
        policyStatusTypeList,
        goodsTypeList,
        orderInfo: {},
        flowStatusList: [],
        instedArr: [], //被投保人
        imagesFiles: [], //影像文件
        benefitsArr: [], //受益人信息
        productInfos: [], //直投-保障详情
        chaosOrder: {},
        accessoryRisks: {},
        applicant: {},
        beneficiaries: [],
        insureds: [],
        // chaosOrderStatusProgress: [],
      };
    },
    computed: {
      payYears() {
        let payYears = "";
        switch (this.chaosOrder.payYearsType) {
          case "1":
            payYears = `缴${this.chaosOrder.payYears}年`;
            break;
          case "2":
            payYears = `缴到${this.chaosOrder.payYears}岁`;
            break;
          default:
            payYears = this.chaosOrder.payYears;
            break;
        }
        return payYears;
      },
      insuredPeriod() {
        let insuredPeriod = "";
        switch (this.chaosOrder.insuredPeriodType) {
          case "1":
            insuredPeriod = `${this.chaosOrder.insuredPeriod}年`;
            break;
          case "2":
            insuredPeriod = `保至到${this.chaosOrder.insuredPeriod}岁`;
            break;
          case "3":
            insuredPeriod = `保${this.chaosOrder.insuredPeriod}天`;
            break;
          case "4":
            insuredPeriod = `保终身`;
            break;
          case "5":
            insuredPeriod = `保${this.chaosOrder.insuredPeriod}月`;
            break;
          case "6":
            insuredPeriod = `保${this.chaosOrder.insuredPeriod}周`;
            break;
          default:
            insuredPeriod = this.chaosOrder.insuredPeriod;
            break;
        }
        return insuredPeriod;
      },
    },
    beforeCreate() {},
    created() {
      const orderCode = this.code;
      if (orderCode) {
        this.getDetail(orderCode);
      }
    },
    beforeMount() {},
    mounted() {},
    methods: {
      relation,
      identityType,
      gender,
      // backPolicy() {
      //   const orderCode = this.$route.query.orderCode
      //   insureOrderRefund({ orderCode: orderCode }).then(res=>{
      //     if(res.code===10000){
      //       this.getDetail(orderCode)
      //     }
      //   })
      // },
      goBack() {
        // 返回
        this.$emit("state-change", "1");
      },
      // 初始化被保人列表
      initInstedDList(data, dataArr) {
        data &&
          data.length &&
          data.forEach((item) => (item.userList = dataArr[item.id]));
        console.log(data, "hehe");
        return data;
      },
      // 初始化受益人列表
      initBenefitList(data, dataArr) {
        data &&
          data.length &&
          data.forEach(
            (item) =>
            (item.userList = dataArr[item.belongTo] ?
              Object.values(dataArr[item.belongTo]) :
              null)
          );
        console.log("sjsjjsjs", data);
        return data;
      },
      getDetail(orderCode) {
        // 获取详情
        this.orderInfo = {};
        this.flowStatusList = [];
        this.instedArr = []; //被投保人
        this.imagesFiles = []; //影像文件
        this.benefitsArr = []; //受益人信息
        queryChaosOrderDetail({
          channelNo:"8093322e7b2c11eba6d67cd30aeb1984",
          orderCode: orderCode
        }).then((res) => {
          const response = res.data || {};
          if (response.code == 10000) {
            this.orderInfo = response.data.orderInfo;
            console.log(response.data, "aa");
            if (response.data.orderInfo.orderDetail) {
              // 保障详情
              let productInfosArr = flatten(
                response.data.orderInfo.orderDetail.productInfos
              );
              this.productInfos = productInfosArr;

              // 被保人信息
              this.initInstedDList(
                response.data.orderInfo.insureds,
                response.data.orderInfo.orderDetail.insureds
              ); //初始化被保人列表

              // 受益人信息
              this.initBenefitList(
                response.data.orderInfo.benefit,
                response.data.orderInfo.orderDetail.benefits
              );
              // 受益人信息
              const valuesBenefits = response.data.orderInfo.orderDetail.benefits;
              const benefitsArr = [];
              for (const key in valuesBenefits) {
                for (const key2 in valuesBenefits[key]) {
                  benefitsArr.push(valuesBenefits[key][key2]);
                }
              }
              this.benefitsArr = benefitsArr;

              // 影像信息文件
              const imagesFilesArr = Object.values(
                response.data.orderInfo.orderDetail.images
              );
              this.imagesFiles = flatten(imagesFilesArr);
            }
            this.flowStatusList = response.data.statusList ?
              response.data.statusList :
              [];
          } else {
            this.$message(res.msg || "接口出错");
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .query-detail {
    width: 100%;

    .divider {
      flex: 1;
      height: 1.5px;
      opacity: 0.1;
      background: #000000;
    }

    .description {
      margin-top: 30px;

      .qd-header {
        display: flex;
        align-items: center;

        span {
          width: 85px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #9a9a9a;
          line-height: 22px;
        }
      }

      .qd-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
        padding-bottom: 13px;
        margin-left: 80px;
      }

      .content {
        padding-top: 24px;
        padding-left: 85px;
        display: grid;
        grid-auto-rows: minmax(34px, auto);
        grid-template-columns: repeat(3, 1fr);

        .desc-item {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          line-height: 34px;
          display: flex;

          span:first-child {
            flex-shrink: 0;
          }

          span {
            display: inline-flex;
          }

          .label {
            // color: #9a9a9a;
            color: #333333;
          }

          .text {
            color: #333333;
          }
        }
      }
    }

    .footer-area {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 48px 0 0;

      .bottom-btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 40px;
        background: #ebebeb;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
        border: 1px solid #f5f5f5;
      }
    }
  }

  ::v-deep .el-form-item__label {
    font-weight: 600;
    color: #9a9a9a;
  }
</style>